// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../procollege/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../procollege/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admission-statistic[data-v-524bc7de]{width:100%}`, "",{"version":3,"sources":["webpack://./../blocks/manage_groups/admission/statistic/components/statistic.vue"],"names":[],"mappings":"AACA,sCACE,UAAA","sourcesContent":["\n.admission-statistic {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
